<template>
  <div v-loading="loading" class="rj-page-card">
    <div class="rj-page-card__title">
      汇率
    </div>
    <div class="rj-page-card__content">
      <div class="baseInfoForm">
        <div class="rj-row">
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                是否跨币种：
              </div>
              <div class="rj-baseinfo__item">
                {{ form.crossCurrencyFlag === 1 ? '是' : '否' }}
              </div>
            </div>
          </div>
          <template v-if="form.crossCurrencyFlag === 1">
            <div class="rj-col-3">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  汇率取值规则：
                </div>
                <div class="rj-baseinfo__item">
                  {{ form.exchangeRateRule === 'sameDayMiddleRate' ? '客户付款当日汇率中间价' : 'PO 约定汇率' }}
                </div>
              </div>
            </div>
            <div class="rj-col-3">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  汇率日期：
                </div>
                <div class="rj-baseinfo__item">
                  {{ form.exchangeRateDate }}
                </div>
              </div>
            </div>

            <div class="rj-col-3 relative">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  目标币种：
                </div>
                <div class="rj-baseinfo__item">
                  {{ form.targetCurrency }}
                </div>
              </div>
              <div v-if="form.exceptionType === 1" class="absolute top-15 text-yellow-500">本次应收金额与转换金额差异超过1（{{ form.targetCurrency }}），请核对.</div>
              <div v-if="form.exceptionType === 2" class="absolute top-15 text-yellow-500">本次跨币种核销与本月公司汇率相比波动超过5%</div>
            </div>
            <div class="rj-col-3">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  汇率值：
                </div>
                <div class="rj-baseinfo__item">
                  {{ form.exchangeRate }}
                </div>
              </div>
            </div>
            <div class="rj-col-3">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  本次应收金额：
                </div>
                <div class="rj-baseinfo__item">
                  {{ form.currentReceivableAmount }}
                </div>
              </div>
            </div>
            <div class="rj-col-3">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  转换金额：
                </div>
                <div class="rj-baseinfo__item">
                  {{ form.convertedAmount }}
                </div>
              </div>
            </div>
            <div class="rj-col-3">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">&nbsp;</div>
                <div class="rj-baseinfo__item">&nbsp;</div>
              </div>
            </div>
            <div class="rj-col-3">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  关联虚拟来款单：
                </div>
                <div class="rj-baseinfo__item">
                  {{ form.virtualTelegraphicTransferNo }}
                </div>
              </div>
            </div>
            <div class="rj-col-1">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  虚拟来款单备注：
                </div>
                <div class="rj-baseinfo__item">
                  {{ form.erpVirtualReceiptRemark }}
                </div>
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>
<script type="es6">
export default {
  data () {
    return {
      loading: false,
      isshows: true
    };
  },
  model: {
    prop: 'form',
    event: 'change'
  },
  props: {
    form: {
      type: Object,
      default: () => { return {}; }
    }
  }
};
</script>
<style lang="scss">
  .baseInfoForm {
    .el-form-item--mini.el-form-item {
      margin-bottom: 0;
    }
  }
</style>
<style lang="scss">
  .baseInfoForm{
    .el-form-item__error{
      position: relative;
    }
  }
  .required{
    color: red;
    margin-left: 3px;
  }
</style>
